<div  class="componentSearchInput">

    @if (showSearch) {
        <div 
            mat-icon-button
            [ngClass]="[openSearch ? 'searchInput searchInput__open' : 'searchInput']"
        >   
            @if (showPrefix) {
                <span class="fontDefault">em:{{prefix}}
                    <mat-icon class="x" [ngStyle]="{'margin-left':'4px'}" (click)="openSearchBar()">cancel</mat-icon>
                </span>
            }

            <input 
                #inputSearch
                type="text"
                [placeholder]="placeholder"
                (keyup)="searching($event)"
                [(ngModel)]="valorInput"
            >

            <button 
                mat-icon-button 
                [ngStyle]="{'margin':'0 4px'}"
                [matTooltip]="openSearch && showPrefix ? 'Limpar Busca' : openSearch && !showPrefix ? 'Fechar' : 'Buscar'"
                [disabled]="searchingLoad"
                (click)="openSearchBar()" 
            >
                <mat-icon 
                    [ngStyle]="{'color':'#fff'}"
                    [svgIcon]="openSearch ? 'close' : searchingLoad ? 'loading' : 'magnify'"
                    [ngClass]="[searchingLoad ? 'loading' : '', openSearch ? 'icon-search-open' : 'icon-search-close']"
                ></mat-icon>
            </button>

        </div>
    }

    <!-- Icon para abrir as notificações -->
    <button #notificacoesMenuTrigger mat-icon-button class="toolbar_notificacoes" [matMenuTriggerFor]="notificacoesMenu">
        <mat-icon svgIcon="bell"></mat-icon>
    </button>

    <mat-menu #notificacoesMenu xPosition="before">
        <app-notificacoes></app-notificacoes>
    </mat-menu>


    @if (mostraFiltro) {
        <button *showIfAuthorized="showIfAuthorizedName"
            mat-icon-button
            [ngStyle]="{'margin':'0 4px'}"
            (click)="openFilter()"
        >
            <!-- fazer verificação de rota e variaveis para aparecer a notificação no icon -->
            <mat-icon 
                svgIcon="filter"
                [ngClass]="{'badgeCustom': showBadgeFiltro}"
            >
            </mat-icon>
    
        </button>
    }

    @if (!utilsService.isMobile) {
        <perfil-usuario [ngStyle]="{'margin-letf':'4px'}"></perfil-usuario>
    }
</div>